import _ from 'lodash';
import { mediaHelpers } from '../../../../../global/viewSettings/importing/mediaResults';
import { _fetchModes } from '../../../elements/matches/MatchDataUpdate';
import { _mediaHeaders, matchStatusTypes } from '../SportsDataReducer';
import { ammendTeamName } from '../SportsMatchReducer';
import { getMatchUpdates } from './sportsGsData';
import { getMatchInfo } from './sportsGsUpdates';

const _removeProps = [
  '_itemKey',
  'parentKeys',
  'position',
  'combined',
]

export const _teamsFoundTypes = {
  bothTeams: 'bothTeams',
  singleTeam: 'singleTeam',
  noTeams: 'noTeams'
}

export const _matchFoundTypes = {
  cancelled: 'cancelled',
  dateChanged: 'dateChanged',
  duplicated: 'duplicated',
  exhibition: 'exhibition',
  existingDb: 'existingDb',
  inversed: 'inversed',
  matchIsNew: 'matchIsNew',
  new: 'new',
  nonDistrict: 'nonDistrict',
  removed: 'removed',
  scoreChanged: 'scoreChanged',
  scoreIsNew: 'scoreIsNew',
}

const normalizeGsMatches = (matches, checkProps, ammendProps) => {
  _.forEach(matches, (match) => {
    _.forEach(checkProps, (checkKey, i) => {
      const ammendKey = ammendProps[i];
      const value = _.get(match, checkKey);

      if (value && !_.get(match, ammendKey)) {
        if (ammendKey === "sections" && !isNaN(Number(value)) && _.isFinite(Number(value))) {
          _.set(match, ammendKey, `section${Number(value)}`);
        } else {
          _.set(match, ammendKey, value);
        }
      }

      _.unset(match, checkKey);
    });
  });

  return matches;
};

const getMatchKey = (match) => {
  return [
    match.startDate,
    match.home,
    match.away,
  ].join('|')
}

const toArray = value => _.isArray(value) ? value : _.values(value)
const validMatch = m => m?.startDate && m?.away && m?.home //&& m?.updateTypes !== 'Cancelled'// && m?.updateTypes !== 'Postponed'


/**
 * return matchResultsInfo
 * @param {*} matches_gs 
 * @param {*} matches_flat 
 * @param {*} matches_info 
 * @param {*} teams 
 * @param {*} gameScoringType 
 * @param {*} callback 
 * @param {*} forPlayoffs 
 * @param {*} forRefresh 
 */
export const ammendMatchesFromGsOrMedia = (
  mainDb,
  action,
  matches_flat,
  matches_info,
  teams,
  gameScoringType,
  callback,
  pathViews
) => {

  const { gsValues, results_gs, mediaMatches, forPlayoffs, forRefresh } = action

  const { fetchMode } = gsValues ?? {}
  const matches_gs = results_gs ? results_gs : mediaMatches

  switch (fetchMode) {
    case _fetchModes.wpialResults:
      parseSheetData(results_gs.values)
      break;

    default:
      const _matches_info = []

      // from the app
      const { matches, matches_playoffs } = matches_info ?? {}
      const { values } = matches_flat ?? {}

      // these are the flattend existing matches from the app
      const { season: matches_flat_season, playoffs: matches_flat_playoff } = values ?? {}

      if (matches_gs && (matches_flat_season || matches_flat_playoff)) {

        const _matchesGs = _.filter(toArray(matches_gs), validMatch)
        const _matches_flat_season = _.filter(toArray(matches_flat_season), validMatch)


        const appMatchesNotInGs = _.differenceBy(
          toArray(_matches_flat_season),
          toArray(_matchesGs),
          getMatchKey
        )

        const gsMatchesNotInApp = _.differenceBy(
          toArray(_matchesGs),
          toArray(_matches_flat_season),
          getMatchKey
        )

        console.group('ammendMatchesFromGsOrMedia')
        console.log('_matchesGs', _matchesGs)
        console.log('appMatchesNotInGs', appMatchesNotInGs)
        console.log('gsMatchesNotInApp', gsMatchesNotInApp)
        console.groupEnd()

        // get only the GS MATCHES that have a startDate, home and away teams.
        const matches_gs_actual = _.filter(matches_gs, (match) => (!_.isNil(match.startDate) && !_.isNil(match.away) && !_.isNil(match.home)));

        normalizeGsMatches(matches_gs_actual, ['section', 'level'], ['sections', 'levels'])

        // loop the GS MATCHES and ammend the levels, if needed
        _.forEach(matches_gs_actual, (match_gs) => {
          const { home, away, _lsp } = match_gs
          if (_lsp?.level === 'tbd') {
            const _h = _.find(teams, { name: home })
            const _a = _.find(teams, { name: away })
            const _levels_h = _h?.levels
            const _levels_a = _a?.levels
            if (_levels_h && _levels_a && (_levels_h === _levels_a)) {
              match_gs.levels = _levels_h
            } else {
              match_gs.levels = _mediaHeaders.nonLevel
            }
          }
        })

        ammendMatchTeamNames(matches_gs_actual)

        const matchResultsInfo = getMatchUpdates(mainDb, matches_info, matches_gs_actual, teams, forPlayoffs, forRefresh, gameScoringType)
        const { matchUpdates_data } = matchResultsInfo ?? {}


        matchResultsInfo.appMatchesNotInGs = appMatchesNotInGs
        matchResultsInfo.gsMatchesNotInApp = gsMatchesNotInApp
        matchResultsInfo.matches_gs = matches_gs

        const m_flat = forPlayoffs ? matches_flat_playoff : matches_flat_season
        const _matches_flat = _.cloneDeep(m_flat)
        const _matches_db = forPlayoffs ? matches_playoffs : matches

        console.log('_matches_db', _matches_db)

        // loop the matches_gs
        _.forEach(matches_gs_actual, (match_gs, dk) => {
          match_gs._matchStatusTypes = []
          const match_info = getMatchInfo(_matches_flat, match_gs, teams, _matches_db)
          _matches_info.push(match_info)
        })
        const matches_info_grouped = _.groupBy(_matches_info, 'matchFoundType')

        _.forEach(matches_info_grouped, (matches_info_group, mft) => {
          switch (mft) {
            case _matchFoundTypes.cancelled:
              // nothing
              break;

            case _matchFoundTypes.existingDb:
            case _matchFoundTypes.new:
              _.forEach(matches_info_group, (_match_info, mgk) => {
                const _match_flat = _matches_flat[_match_info.matchFlatKey]
                if (_match_flat) {
                  _match_flat._matchStatusTypes = _match_info.matchStatusTypes
                  ammendFlatMatch(_match_flat, _match_info)
                }
              })
              break;
            default:
            // nothing
          }
        })

        mediaHelpers.createAlignmentsFromMatches(matches_gs, teams)
        createAlignments(matchUpdates_data)

        callback(matchResultsInfo, forPlayoffs)
      }
  }


}

const createAlignments = (matchDataUpdates) => {

  const { allUpdates: matches } = matchDataUpdates ?? {}

  const levels = {};

  _.forEach(matches, (matchesByLevel, level) => {
    if (!levels[level]) {
      levels[level] = {
        name: level,
        sections: {}
      };
    }

    _.forEach(matchesByLevel, (match) => {
      const awaySection = match.away.sections;
      const homeSection = match.home.sections;

      if (!levels[level].sections[awaySection]) {
        levels[level].sections[awaySection] = { teams: {} };
      }
      if (!levels[level].sections[homeSection]) {
        levels[level].sections[homeSection] = { teams: {} };
      }

      levels[level].sections[awaySection].teams[match.away.id] = { name: match.away.name, id: match.away.id };
      levels[level].sections[homeSection].teams[match.home.id] = { name: match.home.name, id: match.home.id };
    });
  });

}
/**
 * Changes the team names to names to the correct names, if needed.
 * @param {object} matches_gs 
 */
const ammendMatchTeamNames = (matches_gs) => {
  Object.keys(matches_gs).forEach(k => {
    const match_gs = matches_gs[k]
    const { home, away } = match_gs
    if (home && away) {
      match_gs.home = ammendTeamName(home)
      match_gs.away = ammendTeamName(away)
    }
  })
}

/**
 * 
 * @param {object} match_flat 
 * @param {object} match_group 
 */
const ammendFlatMatch = (match_flat, match_group) => {

  const { match_gs, matchScores, inversed } = match_group ?? {}
  let { startDate: startDate_gs, postponed, cancelled, exhibition } = match_gs ?? {}

  if (!match_flat._matchStatusTypes) {
    match_flat._matchStatusTypes = []
  }

  // chaget the date if needed
  if (match_group && startDate_gs && startDate_gs !== match_group.startDate) {
    match_flat._matchStatusTypes.push(matchStatusTypes.dateChanged)
    match_flat._newStartDate = startDate_gs
  }

  // still updating the match, but ammending the matchStatusTypes
  if (postponed) { match_flat._matchStatusTypes.push(matchStatusTypes.postponed) }
  if (cancelled) { match_flat._matchStatusTypes.push(matchStatusTypes.cancelled) }
  if (exhibition) { match_flat._matchStatusTypes.push(matchStatusTypes.exhibition) }

  if (matchScores && matchScores.gs) {
    // if `gs` has scores for `home` and `away`
    if (_.isNumber(matchScores.gs.away) && _.isNumber(matchScores.gs.home)) {
      // if `found` has scores for `home` and `away`
      if (matchScores.db && _.isNumber(matchScores.db.away) && _.isNumber(matchScores.db.home)) {
        // if `found` and `gs` scores are different
        if ((matchScores.gs.home !== matchScores.db.home) || (matchScores.gs.away !== matchScores.db.away)) {
          match_flat._matchStatusTypes.push(matchStatusTypes.scoreChanged)
          if (inversed) {
            inverseMatch(match_flat, matchScores)
          } else {
            match_flat.awayScore = parseInt(matchScores.gs.away)
            match_flat.homeScore = parseInt(matchScores.gs.home)
          }
        }
      } else {
        // if `gs` has scores for `home` and `away`
        if (_.isNumber(matchScores.gs.away) && _.isNumber(matchScores.gs.home)) {
          match_flat._matchStatusTypes.push(matchStatusTypes.scoreChanged)
          if (inversed) {
            inverseMatch(match_flat, matchScores)
          } else {
            match_flat.awayScore = parseInt(matchScores.gs.away)
            match_flat.homeScore = parseInt(matchScores.gs.home)
          }
        }
      }
    }
  }
}

const inverseMatch = (match_flat, matchScores) => {
  match_flat.old = {
    away: match_flat.away,
    home: match_flat.home
  }
  match_flat.away = match_flat.old.home
  match_flat.home = match_flat.old.away
  match_flat.awayScore = matchScores.gs.away
  match_flat.homeScore = matchScores.gs.home
  match_flat._matchStatusTypes.push(matchStatusTypes.inversed)
}


function parseSheetData(sheetData) {

  const teams = {};

  let currentTeams = [];
  let currentHeaders = [];
  let currentMatchIndices = {};

  const toCamelCase = (str) => {
    return _.camelCase(str)
  };

  for (let rowIndex = 0; rowIndex < sheetData.length; rowIndex++) {
    const row = sheetData[rowIndex];
    if (row.length === 0 || row.every(cell => !cell)) {
      // Empty row, reset context
      currentTeams = [];
      currentHeaders = [];
      continue;
    }

    // Identify all header sections in the row
    let headerStartIndices = [];
    row.forEach((cell, index) => {
      if (cell === "DATE") {
        headerStartIndices.push(index);
      }
    });

    if (headerStartIndices.length > 0) {
      // There are one or more header sections in the row
      const previousRow = sheetData[rowIndex - 1] || [];

      currentTeams = headerStartIndices.map((startIndex, headerIndex) => {
        const endIndex = row.indexOf("S/NS", startIndex);
        const headers = row.slice(startIndex, endIndex + 1).map(toCamelCase);
        const teamName = previousRow[startIndex]?.trim() || `Unknown Team ${headerIndex}`;
        const _teamName = ammendTeamName(teamName)
        if (!teams[_teamName]) {
          teams[_teamName] = { matches: {} };
          currentMatchIndices[_teamName] = 0;
        }
        return { teamName: _teamName, headers, startIndex, endIndex };
      });
      continue; // Skip processing the header row as a match
    }

    // Process rows as match data under each team's headers
    if (currentTeams.length > 0) {
      currentTeams.forEach(({ teamName, headers, startIndex, endIndex }) => {

        const matchData = row.slice(startIndex, endIndex + 1);
        const match = {};
        headers.forEach((header, index) => {
          switch (header) {
            case 'opponenxxxt':
              match[header] = ammendTeamName(matchData[index]) ?? "";
            default:
              match[header] = matchData[index] ?? "";
          }
        });
        // const _teamName = ammendTeamName(teamName)
        teams[teamName].matches[`match_${currentMatchIndices[teamName]++}`] = match;
      });
    }
  }

  return teams;
}
